<template>
  <span v-if="!isProUser" class="tag pro-tag is-small is-secondary m-l-5">pro</span>
</template>

<script>
export default {
  name: 'ProTag',
  computed: {
    isProUser () {
      return this.$store.getters.isProUser
    }
  }
}
</script>

<style scoped lang="scss">
.pro-tag {
  text-decoration: none;
  padding: 0 4px 2px;
  height: auto;
  transform: scale(0.9);
}
</style>
